import {mount} from "svelte";

import App from "./svelte/App.svelte";

mount(App, {target: document.body});
